export default __webpack_public_path__ + "static/media/_DSC0364.5762c973.JPG";